import React, { useState, useEffect } from 'react';
import styles from './header.css';

/**
 *
 * @type {React.NamedExoticComponent<{readonly calendar?: *, readonly settings?: *, readonly style?: *, readonly logo?: *, readonly setNavigationView?: *, readonly content?: *, readonly isHeaderLight?: *}>}
 */
const Header = React.memo( ( { setNavigationView, settings, logo, content, style, calendar, isHeaderLight } ) => {

    const { prizes, leaderboard, winners, rules, appearance } = settings;
    const headerTextColor = isHeaderLight ? 'rgba(0,0,0,0.8)' : 'rgba(255,255,255,0.8)';
    const [ currentView, setCurrentView ] = useState( null );
    const { appearance:{highlight_color} } = settings;
    const handleSetView = ( view ) => {
        setCurrentView( view );
    };

    useEffect( () => {
        setNavigationView( currentView );
    }, [ currentView ] );

    return (
        <div style={ calendar.topMenuStyle ?
            {
                ...style,
                backgroundColor: calendar.topMenuStyle.borderColor,
                fontFamily: appearance.font_style ? appearance.font_style.fontFamily : 'Overpass, sans-serif'
            } :
            {
                ...style,
                fontFamily: appearance.font_style ? appearance.font_style.fontFamily : 'Overpass, sans-serif'
            } } className={ styles.wrapper }>
            <div className={ styles.subWrapper }>
                { logo &&
                <div className={ styles.logoWrapper }>
                    <img
                        src={ logo }
                        alt={ 'logo' }
                        className={ styles.logo }
                        style={ ( calendar.topMenuStyle && calendar.topMenuStyle.logoSize != 0 ) ? {
                            height: `${ calendar.topMenuStyle.logoSize }px`,
                            width: 'auto'
                        } : {} }
                    /></div>
                }
                <div className={ styles.navItems }>
                    { ( prizes || leaderboard || winners || rules ) &&
                    <div
                        style={ !( currentView === null ) ? {
                            color: `${ headerTextColor }`,
                            borderBottom: `2px solid ${ headerTextColor }`
                        } : { color: `${ highlight_color }`, borderBottom: `2px solid  ${ highlight_color }` } }
                        className={ styles.navItem }
                        aria-label={ content.calendar.start_aria_label }
                        onClick={ () => handleSetView( null ) }>
                        { content.calendar.start }
                    </div> }
                    { prizes &&
                    <div
                        style={ !( currentView === 'prizes' ) ? {
                            color: `${ headerTextColor }`,
                            borderBottom: `2px solid ${ headerTextColor }`
                        } : { color: `${ highlight_color }`, borderBottom: `2px solid  ${ highlight_color }` } }
                        className={ styles.navItem }
                        onClick={ () => handleSetView( 'prizes' ) }>
                        { content.calendar.prizes }
                    </div> }
                    { leaderboard && <div
                        style={ !( currentView === 'leaderboard' ) ? {
                            color: `${ headerTextColor }`,
                            borderBottom: `2px solid ${ headerTextColor }`
                        } : {  color: `${ highlight_color }`, borderBottom: `2px solid  ${ highlight_color }`  } }
                        className={ styles.navItem }
                        onClick={ () => handleSetView( 'leaderboard' ) }>
                        { content.calendar.leaderboard }
                    </div> }
                    { winners && <div
                        style={ !( currentView === 'winners' ) ? {
                            color: `${ headerTextColor }`,
                            borderBottom: `2px solid ${ headerTextColor }`
                        } : { color: `${ highlight_color }`, borderBottom: `2px solid  ${ highlight_color }`  } }
                        className={ styles.navItem }
                        onClick={ () => handleSetView( 'winners' ) }>
                        { content.calendar.winners }
                    </div> }
                    { rules && <div
                        style={ !( currentView === 'rules' ) ? {
                            color: `${ headerTextColor }`,
                            borderBottom: `2px solid ${ headerTextColor }`
                        } : {  color: `${ highlight_color }`, borderBottom: `2px solid  ${ highlight_color }` } }
                        className={ styles.navItem }
                        onClick={ () => handleSetView( 'rules' ) }>
                        { ( calendar.rules !== null ) && calendar.rules.label_text ? calendar.rules.label_text : content.calendar.rules }
                    </div> }
                </div>
            </div>
        </div>
    );
} );

export default Header;